<template>
	<div class="col-12">
		<div class="card">
			<div class="card-header">
			<h4 class="card-header-title">Attach Documents to Quote</h4>
			</div>
			<div class="card-body">
			<div id="dropzone" ref="dropzone">
				<div class="upload">
					Drop Files here or <span class="browse">browse</span>
				</div>

				<div id="dz-template" class="dz-template" ref="template">
					<ul class="files">
						<li>
						<span class="extension"></span>
						<span class="filename truncate" data-dz-name></span>
						<a href="#" class="remove-file"><i class="mdi mdi-close"></i></a>
						<div class="progress hidden">
							<div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div>
						</div>
						</li>
					</ul>
				</div>

				<ul class="dropzone-files">
				</ul>
			</div><!-- /.#dropzone -->

			<ul class="file-download">
				<DocumentItem v-for="(document, index) in documents" :file="document" :index="index" :key="document.id"/>
			</ul>

			</div>
		</div><!-- /.card -->
	</div>
</template>

<script>
 
	import Dropzone from 'dropzone'
	import { round, toUpper } from 'lodash'
	import { notify, apiUrl, http } from 'utils'
	import { mapState, mapActions, mapGetters } from 'vuex'

	import DocumentItem from './DocumentItem'

    export default {
        components: {
			DocumentItem
		},

        data: function () {
            return {
				
            }
        },
        
        computed: {
			...mapState('opportunity', {
                opportunity: 'single'
			}),
			...mapState('opportunity/documents', {
                documents: 'list'
			}),
			...mapGetters('opportunity', ['isSigned']),

        },
		mounted () {

			this.getDocuments();

			this.dz = new Dropzone(this.$refs.dropzone, {
				url: apiUrl(`opportunities/${this.opportunity.id}/documents`),
				withCredentials: false,
				maxFilesize: 15,
				acceptedFiles: '.jpg, .jpeg, .png, .txt, .pdf, .doc, .docx, .csv, .xls, .xlsx',
				clickable: '.upload > .browse',
				previewTemplate: this.$refs.template.innerHTML,
				previewsContainer: '.dropzone-files'
			})

			this.dz.on('sending', function (file, xhr, formData) {
				$(file.previewElement).find('.progress').removeClass('hidden')
				$(file.previewElement).find('.remove-file').addClass('hidden')

				//xhr.setRequestHeader('Authorization', `Bearer ${auth.getToken()}`)
			})

			this.dz.on('addedfile', this.handleFileExtension)
			this.dz.on('success', this.handleUploadSuccessCallback)
			this.dz.on('error', this.handleUploadErrorCallback)


		},
        methods: {
			...mapActions('opportunity', {
                updateOpportunity: 'updateSingle'
			}),
			...mapActions('opportunity/documents', {
				getDocuments: 'getList'
			}),
			async downloadFile (document) {
				if (document.id) {
					window.location.href = apiUrl(`files/${document.id}`)
				}

				return Promise.resolve()
				},

			fileSize (document) {
				return round(document.file_size / 1000000, 2)
			},

			fileExtension (document) {
				return toUpper(document.extension)
			},
			async handleUploadSuccessCallback (file, response) {

				if (file.id === undefined || file.id === null) {
					file.id = response.data.id
					await this.getDocuments()
				}

				this.$nextTick(() => {
					$(file.previewElement).remove()
				})
			},

			handleUploadErrorCallback (file, message) {
				let fileSizeLimit = this.dz.options.maxFilesize * 1024 * 1024

				$(file.previewElement).remove()

				if (message === 'You can\'t upload files of this type.') {
					notify.error('File type not supported. Please upload one of the following: jpg,jpeg,png,txt,pdf,doc,docx,csv,xls,xlsx')
				} else if (file.size > fileSizeLimit) {
					notify.error('File size too large, please upload a file under 5MB')
				} else {
					notify.error('There was a problem uploading the file.')
				}
			},

			/**
			 * Set the extension in the preview element from the added file.
			 *
			 * @param object file
			 *
			 * @return void
			 */
			handleFileExtension (file) {
			let extension = 'FILE'

			if (file.name.lastIndexOf('.') !== -1) {
				extension = file.name.substr(file.name.lastIndexOf('.') + 1).toUpperCase()
			}

			$(file.previewElement).find('span.extension').html(extension)
			}

        }
    }
</script>
